import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            padding: remCalc(16),
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            gap: remCalc(16),
            alignItems: 'center',
        },
        label: {
            p: remCalc(8),
            pb: remCalc(4),
            color: 'label.text.secondary',
            backgroundColor: 'label.background.secondary',
            fontWeight: 'bold',
            textStyle: 'body-small',
            textTransform: 'uppercase',
            borderRadius: remCalc(8),
        },
        bodycopy: {
            color: 'foreground.neutral.default',
            fontWeight: 'normal',
            textStyle: 'body-small',
        },
    },
}
